import API from '../../../../../services/api';

export const API_DIRECCIONES = {
    newDireccion: async (direccion) => {
        return API.post('/direcciones', direccion).then(res => res.data);
    },
    updateDireccion: async (direccion) => {
        return API.put('/direcciones/' + direccion.id, direccion).then(res => res.data);
    }
}